// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"a69b98a3","488":"d9fe1294"}[chunkId] + ".chunk.js";
};